module.exports = __webpack_public_path__ + "static/website.27c2fbd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/website.jpg
// module id = 840
// module chunks = 59393608157790